import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getCountries } from "../ApiService/ApiService";

export const fetchCountriesAsync = createAsyncThunk(
  "countries/fetchCountries",
  async () => {
    const response = await getCountries();
    return response.data;
  }
);

const initialState = {
  countries: [],
  loading: false,
  error: null,
};

export const countriesSlice = createSlice({
  name: "countries",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCountriesAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCountriesAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.countries = action.payload.data;
      })
      .addCase(fetchCountriesAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const selectAllCountries = (state) => state.countries.countries;
export const selectCountriesLoading = (state) => state.countries.loading;
export const selectCountriesError = (state) => state.countries.error;

export default countriesSlice.reducer;
